import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-lauout',
  templateUrl: './main-lauout.component.html',
  styleUrls: ['./main-lauout.component.sass']
})
export class MainLauoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.log("Main")
  }

}
